/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISharepoint
 */
export interface APISharepoint {
    /**
     * 
     * @type {string}
     * @memberof APISharepoint
     */
    readonly self: string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepoint
     */
    readonly isBomShare: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepoint
     */
    readonly isGuestRequestShare: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepoint
     */
    readonly isRequestShare: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APISharepoint
     */
    readonly createdAt: Date;
    /**
     * Time in days that the sharepoint should be active. This field is used as the single source of truth for the time_to_live of guest users. A share_duration of 0 (days) represents a time-unlimited sharepoint.
     * @type {number}
     * @memberof APISharepoint
     */
    shareDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof APISharepoint
     */
    readonly unreadFeedbackSubmissionCount: number;
    /**
     * 
     * @type {string}
     * @memberof APISharepoint
     */
    readonly feedbackForm: string;
    /**
     * 
     * @type {string}
     * @memberof APISharepoint
     */
    readonly createdBy: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly sharedWith: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly sharedArticles: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly sharedBOMs: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly sharedGuestRequest: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly sharedRequest: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepoint
     */
    readonly feedbackSubmissions: { [key: string]: any; };
}

/**
 * Check if a given object implements the APISharepoint interface.
 */
export function instanceOfAPISharepoint(value: object): value is APISharepoint {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('isBomShare' in value) || value['isBomShare'] === undefined) return false;
    if (!('isGuestRequestShare' in value) || value['isGuestRequestShare'] === undefined) return false;
    if (!('isRequestShare' in value) || value['isRequestShare'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('unreadFeedbackSubmissionCount' in value) || value['unreadFeedbackSubmissionCount'] === undefined) return false;
    if (!('feedbackForm' in value) || value['feedbackForm'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('sharedWith' in value) || value['sharedWith'] === undefined) return false;
    if (!('sharedArticles' in value) || value['sharedArticles'] === undefined) return false;
    if (!('sharedBOMs' in value) || value['sharedBOMs'] === undefined) return false;
    if (!('sharedGuestRequest' in value) || value['sharedGuestRequest'] === undefined) return false;
    if (!('sharedRequest' in value) || value['sharedRequest'] === undefined) return false;
    if (!('feedbackSubmissions' in value) || value['feedbackSubmissions'] === undefined) return false;
    return true;
}

export function APISharepointFromJSON(json: any): APISharepoint {
    return APISharepointFromJSONTyped(json, false);
}

export function APISharepointFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISharepoint {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'isBomShare': json['is_bom_share'],
        'isGuestRequestShare': json['is_guest_request_share'],
        'isRequestShare': json['is_request_share'],
        'createdAt': (new Date(json['created_at'])),
        'shareDuration': json['share_duration'] == null ? undefined : json['share_duration'],
        'unreadFeedbackSubmissionCount': json['unread_feedback_submission_count'],
        'feedbackForm': json['feedback_form'],
        'createdBy': json['created_by'],
        'sharedWith': json['shared_with'],
        'sharedArticles': json['shared_articles'],
        'sharedBOMs': json['shared_BOMs'],
        'sharedGuestRequest': json['shared_guest_request'],
        'sharedRequest': json['shared_request'],
        'feedbackSubmissions': json['feedback_submissions'],
    };
}

export function APISharepointToJSON(value?: Omit<APISharepoint, 'self'|'is_bom_share'|'is_guest_request_share'|'is_request_share'|'created_at'|'unread_feedback_submission_count'|'feedback_form'|'created_by'|'shared_with'|'shared_articles'|'shared_BOMs'|'shared_guest_request'|'shared_request'|'feedback_submissions'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'share_duration': value['shareDuration'],
    };
}

